import { render, staticRenderFns } from "./utreport.vue?vue&type=template&id=1fb85a2d&scoped=true&"
import script from "./utreport.vue?vue&type=script&lang=js&"
export * from "./utreport.vue?vue&type=script&lang=js&"
import style1 from "./utreport.vue?vue&type=style&index=1&id=1fb85a2d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb85a2d",
  null
  
)

export default component.exports